import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BootGuard } from './guards/boot.guard';
import { LayoutComponent } from './pages/layout/layout.component';

const routes: Routes = [{
  path: '',
  children: [
    {
      path: "",
      redirectTo: "boot",
      pathMatch: "full"
    },
    {
      path: "boot",
      component: LayoutComponent,
      loadChildren: () => import('./pages/boot/boot.module').then(m => m.BootModule)
    }
  ]
}, {
  path: 'home',
  canActivate: [BootGuard],
  loadChildren: () => import('./pages/home/home.module').then(m => m.HomeModule),
}];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
